module.exports = __webpack_public_path__ + "static/img/364.cad73bdd.png";